module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_long__square.5061ed29.png";